/** Light colours by `Light.color` (LIGHT_COLOR_COUNT entries) and the golden light's colour. */
export const LIGHT_COLORS: readonly number[] = [
	0xff8a1f, // pumpkin orange
	0xb06bff, // purple
	0x4dff6a, // slime green
	0xff3b5c, // red
	0x3fc8ff, // ice blue
	0xfff06a, // yellow
];
export const GOLDEN_COLOR = 0xffd700;

export function lightColor(index: number, golden: boolean): number {
	return golden ? GOLDEN_COLOR : (LIGHT_COLORS[index % LIGHT_COLORS.length] ?? 0xffffff);
}
/** Trick lights (Oogie Boogie): a toxic green halo round a dark core, unlike the slime green. */
export const TRICK_COLOR = 0x39ff14;
export const TRICK_CORE = 0x0b1a08;
export const BAT_GLOW = 0xb06bff;
export const GHOST_GLOW = 0x9fd8ff;
